import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL + "/tasks.php";

// Get all tasks
export const getTasks = async () => {
  const response = await api.post(API_URL, { action: "getAll" });
  return response.data.tasks;
};
// get Tasks By ProjectId
export const getTasksByProjectId = async (projectId) => {
  const response = await api.post(API_URL, {
    action: "getByProject",
    project_id: projectId,
  });
  return response.data.tasks;
};

// Get a single task by ID
export const getTaskById = async (id) => {
  const response = await api.post(API_URL, { id, action: "get" });
  return response.data.task;
};

// Add a new task
export const addTask = async (formData) => {
  const response = await api.post(API_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Update an existing task
export const updateTask = async (formData) => {
  const response = await api.post(API_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
// Update an existing task status
export const updateTaskStatus = async (id, taskData) => {
  const response = await api.post(API_URL, {
    ...taskData,
    action: "updateStatus",
    id,
  });
  return response.data;
};

// Delete a task
export const deleteTask = async (id) => {
  const response = await api.post(API_URL, { id, action: "delete" });
  return response.data;
};
